import { render, staticRenderFns } from "./presentation.vue?vue&type=template&id=6b6c11a7&scoped=true"
import script from "./presentation.vue?vue&type=script&lang=js"
export * from "./presentation.vue?vue&type=script&lang=js"
import style0 from "./presentation.vue?vue&type=style&index=0&id=6b6c11a7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6c11a7",
  null
  
)

export default component.exports